import API_BASE_URL from '../config/apiBaseUrl';

const tryParseJson = (value) => {
  if (typeof value !== 'string') return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const extractErrorMessage = (data) => {
  if (!data) return null;
  if (typeof data === 'string') return data;

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message;
  }

  if (typeof data.detail === 'string' && data.detail.trim()) {
    const parsed = tryParseJson(data.detail);
    const parsedMessage = extractErrorMessage(parsed);
    return parsedMessage || data.detail;
  }

  if (typeof data['hydra:description'] === 'string' && data['hydra:description'].trim()) {
    return data['hydra:description'];
  }

  if (Array.isArray(data.violations) && data.violations.length > 0) {
    const firstViolation = data.violations[0];
    if (firstViolation?.message) {
      return firstViolation.message;
    }
  }

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const firstError = data.errors[0];
    if (typeof firstError === 'string') return firstError;
    if (firstError?.message) return firstError.message;
  }

  if (data.errors && typeof data.errors === 'object') {
    const firstError = Object.values(data.errors).find((value) => value);
    if (typeof firstError === 'string') return firstError;
  }

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error;
  }

  return null;
};

class NewsletterService {
  async subscribe(email) {
    const response = await fetch(`${API_BASE_URL}/newsletters`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = extractErrorMessage(data);
      throw new Error(message || 'Erreur lors de l\'inscription a la newsletter.');
    }

    return data;
  }

  async confirm(token) {
    const response = await fetch(`${API_BASE_URL}/newsletters/confirm/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = extractErrorMessage(data);
      throw new Error(message || 'Impossible de confirmer la newsletter.');
    }

    return data;
  }

  async unsubscribe(token) {
    const response = await fetch(`${API_BASE_URL}/newsletters/unsubscribe/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = extractErrorMessage(data);
      throw new Error(message || 'Impossible de se desabonner de la newsletter.');
    }

    return data;
  }
}

const newsletterService = new NewsletterService();
export default newsletterService;
